import React from 'react'
import { Menu } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ToggleMenu } from '../../redux/actions/navbar'
import IntelMsg from '../ItelMsg'

const MenuItem = ({ name, to }) => {
  const dispatch = useDispatch()
  return (
    <Menu.Item>
      <Link onClick={() => dispatch(ToggleMenu())} to={to}>
        <div style={{ textAlign: 'left' }}>
          <IntelMsg id={name} />
        </div>
      </Link>
    </Menu.Item>
  )
}

MenuItem.propTypes = {
  name: PropTypes.string,
  to: PropTypes.string,
}
export default MenuItem
